import { HERO_IMAGES_FALLBACK } from '@mock/fallback';
import { ImageApi } from '@model/iceberg/service/image/image-api';
import { Category } from '@model/iceberg';

interface GetHeroOptionsParams {
  path?: string;
  category?: Category;
  count?: number;
  fallback?: string;
}

export const getHero = async (params?: GetHeroOptionsParams) => {
  const { path = '', category, count, fallback } = params || {};
  const api: ImageApi = new ImageApi();
  const imageResponse = await api.images({
    category: category || Category.SCENERY,
    path,
    count
  });
  return imageResponse || fallback || HERO_IMAGES_FALLBACK;
};
